import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import { HomePage } from '../../mumzworld/pages/HomePage';
import { CreateFlowPage } from '../../mumzworld/pages/CreateFlowPage';
import { ComposeAppPage } from '../../mumzworld/pages/ComposeAppPage';
import { CreateAiAgentPage } from '../../mumzworld/pages/CreateAiAgentPage';
import { ApplicationsPage } from '../../mumzworld/pages/ApplicationsPage';
import { ApplicationDetailsPage } from '../../mumzworld/pages/ApplicationDetailsPage';
import { DeploymentsPage } from '../../mumzworld/pages/DeploymentsPage';
import { AiAgentsPage } from '../../mumzworld/pages/AiAgentsPage';
import { DocumentationPage } from '../../mumzworld/pages/DocumentationPage';
import { HelpPage } from '../../mumzworld/pages/HelpPage';

// One plugin (createFrontendPlugin, not createFrontendModule — see
// modules/create-app/index.tsx's comment on why a brand-new route needs the
// former) registering every route the approved simple Mumzworld UI needs.
// '/' is hardcoded here rather than via app-config.yaml's extensions
// override, matching the create-app plugin's existing pattern.

const home = PageBlueprint.make({
  name: 'home',
  params: { path: '/', title: 'Home', noHeader: true, loader: () => Promise.resolve(<HomePage />) },
});

const createFrontend = PageBlueprint.make({
  name: 'create-frontend',
  params: {
    path: '/create/frontend',
    title: 'Create Frontend App',
    noHeader: true,
    loader: () => Promise.resolve(<CreateFlowPage kind="frontend" />),
  },
});

const createBackend = PageBlueprint.make({
  name: 'create-backend',
  params: {
    path: '/create/backend',
    title: 'Create Backend Service',
    noHeader: true,
    loader: () => Promise.resolve(<CreateFlowPage kind="backend" />),
  },
});

const createFullStack = PageBlueprint.make({
  name: 'create-fullstack',
  params: {
    path: '/create/fullstack',
    title: 'Create Full Stack App',
    noHeader: true,
    loader: () => Promise.resolve(<CreateFlowPage kind="fullstack" />),
  },
});

const createCompose = PageBlueprint.make({
  name: 'create-compose',
  params: {
    path: '/create/compose',
    title: 'Create Compose App',
    noHeader: true,
    loader: () => Promise.resolve(<ComposeAppPage />),
  },
});

const createAiAgent = PageBlueprint.make({
  name: 'create-ai-agent',
  params: {
    path: '/create/ai-agent',
    title: 'Create AI Agent',
    noHeader: true,
    loader: () => Promise.resolve(<CreateAiAgentPage />),
  },
});

const createWorker = PageBlueprint.make({
  name: 'create-worker',
  params: {
    path: '/create/worker',
    title: 'Create Worker',
    noHeader: true,
    loader: () => Promise.resolve(<CreateFlowPage kind="worker" />),
  },
});

const createScheduledJob = PageBlueprint.make({
  name: 'create-scheduled-job',
  params: {
    path: '/create/scheduled-job',
    title: 'Create Scheduled Job',
    noHeader: true,
    loader: () => Promise.resolve(<CreateFlowPage kind="scheduled-job" />),
  },
});

const applications = PageBlueprint.make({
  name: 'applications',
  params: {
    path: '/applications',
    title: 'My Applications',
    noHeader: true,
    loader: () => Promise.resolve(<ApplicationsPage />),
  },
});

const applicationDetails = PageBlueprint.make({
  name: 'application-details',
  params: {
    path: '/applications/:id',
    title: 'Application Details',
    noHeader: true,
    loader: () => Promise.resolve(<ApplicationDetailsPage />),
  },
});

const deployments = PageBlueprint.make({
  name: 'deployments',
  params: {
    path: '/deployments',
    title: 'Deployments',
    noHeader: true,
    loader: () => Promise.resolve(<DeploymentsPage />),
  },
});

const aiAgents = PageBlueprint.make({
  name: 'ai-agents',
  params: { path: '/ai-agents', title: 'AI Agents', noHeader: true, loader: () => Promise.resolve(<AiAgentsPage />) },
});

const documentation = PageBlueprint.make({
  name: 'documentation',
  params: {
    path: '/documentation',
    title: 'Documentation',
    noHeader: true,
    loader: () => Promise.resolve(<DocumentationPage />),
  },
});

const help = PageBlueprint.make({
  name: 'help',
  params: { path: '/help', title: 'Help', noHeader: true, loader: () => Promise.resolve(<HelpPage />) },
});

export const mumzworldPlugin = createFrontendPlugin({
  pluginId: 'mumzworld',
  extensions: [
    home,
    createFrontend,
    createBackend,
    createFullStack,
    createAiAgent,
    createWorker,
    createScheduledJob,
    createCompose,
    applications,
    applicationDetails,
    deployments,
    aiAgents,
    documentation,
    help,
  ],
});
